import React from 'react';

//helpers
import {styleable} from 'decorators';

//styled-components
import {Heading} from './styles';

const HeadingBase = styleable(
  ({children, ellipsis, maxLines, device, onClick, size = 'normal', tag = 'h2', dataCy, ...forwardedProps}) => {
    const Tag = Heading.withComponent(tag);

    return (
      <Tag
        device={device}
        ellipsis={ellipsis}
        maxLines={maxLines}
        onClick={onClick}
        size={size}
        data-cy={dataCy}
        {...forwardedProps}
      >
        {children}
      </Tag>
    );
  }
);

export const HeadingDesktop = styleable(props => <HeadingBase device="desktop" {...props} />);

export const HeadingMobile = styleable(props => <HeadingBase device="mobile" {...props} />);
